var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "router-link",
          {
            attrs: {
              tag: "a",
              to: {
                name: "interns.profile.show",
                params: { id: _vm.intern.id },
              },
            },
          },
          [
            _c("div", { staticClass: "col-xs-12 col-md-10" }, [
              _c("div", { staticClass: "details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.intern.name))]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-md-2" },
          [
            !_vm.intern.deleted_at
              ? _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-lg btn-danger btn-job-complete",
                    attrs: { click: _vm.handleDeleteInternCallback },
                  },
                  [
                    [
                      _c("i", { staticClass: "fa fa-trash" }),
                      _vm._v(" Delete User"),
                    ],
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.intern.deleted_at
              ? _c(
                  "div",
                  {
                    staticClass:
                      "btn btn-danger-outline btn-block btn-not-clickable truncate",
                  },
                  [_vm._v("\n        Deleted\n      ")]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }